<script setup lang="ts">
import {Directive} from 'vue';


const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle('bottom-bar-shadow', e.intersectionRatio < 1),
    {
        rootMargin: '0px 0px -1px 0px',
        threshold: [1],
    },
);

const vStickyBottom: Directive = {
    mounted: (el) => observer.observe(el),
};
</script>

<template>
    <div class="bottom-bar-wrapper p-16" v-sticky-bottom>
        <slot/>
    </div>
</template>

<style scoped lang="scss">
.bottom-bar-shadow {
    box-shadow: 0 5px 20px 0 rgba(132, 137, 158, 0.20);
    clip-path: inset(-16px 0px 0px 0px);
}
.bottom-bar-wrapper {
    position: sticky;
    z-index: 6;
    bottom: 0;
    background: white;}
</style>
